<template>
  <error-component v-bind="$attrs" v-slot="{touch, faulty}">
    <label class="grid">
      <select 
        class="inp focus:outline-none appearance-none col-start-1 col-end-2  row-start-1 row-end-2 w-full"
        v-bind="$attrs"
        ref="select"
        :value="filteredValue"
        :class="{faulty, 'border-0': multipart, 'font-bold': multipart, 'opacity-0': !hasSelection}"
        @input="$emit('input', $event.target.value)"
        @blur="touch"
      >
        <option hidden disabled selected value class="hidden"></option>
        <option v-for="[value, label] of entries" :key="value" :value="value">{{label}}</option>
      </select>
      <div class="inp col-start-1 col-end-2 row-start-1 row-end-2 p-3 py-4 pointer-events-none" v-if="!hasSelection">
        {{placeholder}}
      </div>
      <div class="col-start-1 col-end-2 row-start-1 row-end-2 pointer-events-none self-center flex justify-end pr-3" v-if="hasSelection && multipart">
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><path d="M959.021,845.945a.683.683,0,0,0-.966,0l-22.408,22.407-8.706-8.705a.683.683,0,0,0-.966.967l9.189,9.189a.683.683,0,0,0,.966,0l22.891-22.891A.684.684,0,0,0,959.021,845.945Z" transform="translate(-919.237 -834.802)" /></svg>
      </div>
    </label>
  </error-component>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";

export default {
  props: {
    value: String,
    placeholder: String,
    options: [Object, Array],
    multipart: Boolean,
  },
  computed: {
    filteredValue() {
      if(this.hasSelection) {
        return this.value
      } else {
        return ''
      }
    },
    hasSelection() {
      if(Array.isArray(this.options)) {
        return this.options.includes(this.value)
      } else {
        return this.value in this.options
      }
    },
    entries() {
      if(Array.isArray(this.options)) {
        return this.options.map(o => [o, o])
      } else {
        return Object.entries(this.options)
      }
    }
  },
  components: {
    ErrorComponent
  }
}
</script>

<style>

</style>